import { Button, HStack } from "@chakra-ui/react";
import * as React from "react";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { LANGS, langFromPath, localizePath } from "../lib/lang";

const LABELS: Record<string, string> = { pt: "PT", en: "EN" };

const LanguageSwitcher = () => {
  const { pathname } = useLocation();
  const current = langFromPath(pathname);

  return (
    <HStack spacing={1} role="group" aria-label="Language / Idioma">
      {LANGS.map((lang) => {
        const active = lang === current;
        return (
          <Button
            key={lang}
            as={RouterLink}
            to={localizePath(pathname, lang)}
            size="sm"
            fontWeight="bold"
            borderWidth="1px"
            borderColor="#FFF"
            bg={active ? "#FFF" : "transparent"}
            color={active ? "#D03230" : "#FFF"}
            _hover={{ bg: active ? "#FFF" : "whiteAlpha.300" }}
            _active={{ bg: active ? "#FFF" : "whiteAlpha.400" }}
            aria-current={active ? "true" : undefined}
          >
            {LABELS[lang]}
          </Button>
        );
      })}
    </HStack>
  );
};

export default LanguageSwitcher;
